import store from '@/store';

export default (to: any, from: any, next: Function) => {
  return store.state.authToken
    ? next('/')
    : next();
};
